module.exports = __webpack_public_path__ + "media/images/project/duplicate-task-b651991142a4251b7fc20aaa98c5283c.svg";